import { DateTime } from 'luxon';

export const sortByISO = <T>(objects: T[], key: keyof T) => {
  return objects.sort(
    (a, b) =>
      DateTime.fromISO(a[key] as string).toMillis() - DateTime.fromISO(b[key] as string).toMillis()
  );
};
